// mixin.js
import { LocalDateTime } from 'js-joda';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';


// You can declare a mixin as the same style as components.
@Component
export default class LuxtagMixin extends Vue {
    public calculateTime(theMoment: moment.Moment): string {
        // this method will return casual time format such as 3 hours ago
        const time = theMoment;
        const currentTimeMinus1day = moment().subtract(22, 'hour');
        // if the time difference just 1 day it will show like 2 hour ago format
        if (time.isAfter(currentTimeMinus1day)) {
            return time.fromNow(true);
        } else {
            return time.format('MMMM D YYYY');
        }
    }

    public calculateFullTime(theMoment: moment.Moment): string {
        // this method will return full time format
        const time = theMoment;
        return `${time.format('MM/DD/YYYY')} at ${time.format('hh:mm a')}`;
    }
}
